import { jsx as _jsx } from "react/jsx-runtime";
import WarningAltFilled20 from '@carbon/icons-react/es/warning--alt--filled/20';
import styled from 'styled-components';
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const WarningIcon = ({ color = 'var(--red-50)' })=>{
    return /*#__PURE__*/ _jsx(Wrapper, {
        color: color,
        children: /*#__PURE__*/ _jsx(WarningAltFilled20, {
            color: color
        })
    });
};
